import pointcloudVS from './pointcloud.vs';
import pointcloudFS from './pointcloud.fs';
import { Shaders as ViewerShaders } from '../../../viewer-utils/materials/shaders/shaders.js';

export const Shaders: Record<string, string> = {
  'pointcloud.vs': pointcloudVS,
  'pointcloud.fs': pointcloudFS,
  ...ViewerShaders,
};
